import BookingMode from "@/model/BookingMode";

const BOOKING_MODES: BookingMode[] = ["INSTANT", "REQUEST"];

export default BOOKING_MODES;
